import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grape, HelpCircle, Download, CheckCircle2, AlertCircle, AlertTriangle, Copy, ArrowLeft, Home, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function ReconciliationReportPage() {
  const navigate = useNavigate();
  const totalTransactions = 492;
  const matched = 436;
  const matchedPercent = Math.round(matched / totalTransactions * 100);
  const unmatchedItems = [{
    id: 1,
    date: '2025/03/15',
    desc: 'Insurance Premium',
    bankAmt: '-$890.00',
    qbAmt: '-$980.00',
    diff: '$90.00',
    type: 'mismatch'
  }, {
    id: 2,
    date: '2025/03/18',
    desc: 'Equipment Lease',
    bankAmt: '-$1,450.00',
    qbAmt: '-$1,350.00',
    diff: '$100.00',
    type: 'mismatch'
  }, {
    id: 3,
    date: '2025/03/22',
    desc: 'Catering Revenue',
    bankAmt: '+$2,100.00',
    qbAmt: '+$2,300.00',
    diff: '$200.00',
    type: 'mismatch'
  }, {
    id: 4,
    date: '2025/03/20',
    desc: 'ATM Withdrawal',
    bankAmt: '-$200.00',
    qbAmt: '—',
    diff: '',
    type: 'missing'
  }, {
    id: 5,
    date: '2025/03/25',
    desc: 'Bank Fee',
    bankAmt: '-$35.00',
    qbAmt: '—',
    diff: '',
    type: 'missing'
  }, {
    id: 6,
    date: '2025/04/01',
    desc: 'Wire Transfer In',
    bankAmt: '+$5,000.00',
    qbAmt: '—',
    diff: '',
    type: 'missing'
  }, {
    id: 7,
    date: '2025/03/28',
    desc: 'Manual Journal Entry',
    bankAmt: '—',
    qbAmt: '-$500.00',
    diff: '',
    type: 'extra'
  }, {
    id: 8,
    date: '2025/04/02',
    desc: 'Accrued Expense',
    bankAmt: '—',
    qbAmt: '-$750.00',
    diff: '',
    type: 'extra'
  }];
  const duplicateItems = [{
    id: 1,
    date: '2025/03/10',
    desc: 'Supplier - Flour Co.',
    amount: '-$1,200.00',
    occurrences: 2
  }, {
    id: 2,
    date: '2025/03/15',
    desc: 'Insurance Premium',
    amount: '-$890.00',
    occurrences: 2
  }, {
    id: 3,
    date: '2025/03/20',
    desc: 'POS Terminal Fee',
    amount: '-$45.00',
    occurrences: 3
  }];
  const getTypeBadge = (type: string) => {
    switch (type) {
      case 'mismatch':
        return <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-700" data-id="element-750">
            Mismatch
          </span>;
      case 'missing':
        return <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700" data-id="element-751">
            Missing in QB
          </span>;
      case 'extra':
        return <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700" data-id="element-752">
            Extra in QB
          </span>;
      default:
        return null;
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-753">
      {/* Top Bar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-754">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex justify-between items-center" data-id="element-755">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')} data-id="element-756">

            <div className="bg-violet-100 p-1.5 rounded-lg mr-2" data-id="element-757">
              <Grape className="h-5 w-5 text-violet-600" data-id="element-758" />
            </div>
            <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-759">
              Berry Finance
            </span>
          </div>
          <button className="text-sm font-medium text-gray-500 hover:text-gray-900 flex items-center gap-1.5 transition-colors" data-id="element-760">
            <HelpCircle className="h-4 w-4" data-id="element-761" />
            Need help?
          </button>
        </div>
      </header>

      <main className="flex-grow py-10 px-4 sm:px-6 lg:px-8" data-id="element-762">
        <div className="max-w-5xl mx-auto" data-id="element-763">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-764">
            <div data-id="element-765">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-766">
                Reconciliation Results
              </h1>
              <p className="text-gray-600 mt-1" data-id="element-767">
                Larry's Bakery · Cheque Account · 2025/03/01 — 2025/04/05
              </p>
            </div>
            <div className="flex gap-3" data-id="element-768">
              <Button variant="outline" onClick={() => navigate('/matched-result')} data-id="element-769">

                <ArrowLeft className="h-4 w-4 mr-2" data-id="element-770" />
                Back
              </Button>
              <Button variant="primary" data-id="element-771">
                <Download className="h-4 w-4 mr-2" data-id="element-772" />
                Download Excel
              </Button>
            </div>
          </div>

          {/* ── 1. Reconciliation Status ── */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-6" data-id="element-773">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-774">
              <div className="flex items-center gap-4" data-id="element-775">
                <div className="p-3 bg-amber-100 rounded-xl" data-id="element-776">
                  <AlertTriangle className="h-6 w-6 text-amber-600" data-id="element-777" />
                </div>
                <div data-id="element-778">
                  <h2 className="text-lg font-bold text-gray-900" data-id="element-779">
                    Reconciliation Status
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-780">
                    Needs review — {totalTransactions - matched} unresolved
                    items remain
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-bold bg-amber-100 text-amber-700" data-id="element-781">
                <Clock className="h-4 w-4" data-id="element-782" />
                Needs Review
              </span>
            </div>
          </div>

          {/* ── 2. Total Transactions & 3. Matched % ── */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-783">
            {/* Total Transactions */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-784">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3" data-id="element-785">
                Total Transactions
              </p>
              <p className="text-5xl font-bold text-gray-900 mb-2" data-id="element-786">
                {totalTransactions}
              </p>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-787">
                <span className="flex items-center gap-1" data-id="element-788">
                  <CheckCircle2 className="h-3.5 w-3.5 text-green-600" data-id="element-789" />{' '}
                  {matched} matched
                </span>
                <span className="flex items-center gap-1" data-id="element-790">
                  <AlertCircle className="h-3.5 w-3.5 text-red-500" data-id="element-791" />{' '}
                  {totalTransactions - matched} unmatched
                </span>
              </div>
            </div>

            {/* Matched % */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-792">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-3" data-id="element-793">
                Matched Rate
              </p>
              <div className="flex items-end gap-3 mb-3" data-id="element-794">
                <p className="text-5xl font-bold text-green-600" data-id="element-795">
                  {matchedPercent}%
                </p>
                <p className="text-sm text-gray-500 pb-1" data-id="element-796">
                  of transactions matched
                </p>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden" data-id="element-797">
                <div className="h-full bg-green-500 rounded-full transition-all duration-500" style={{
                width: `${matchedPercent}%`
              }} data-id="element-798" />

              </div>
              <div className="flex justify-between mt-2 text-xs text-gray-400" data-id="element-799">
                <span data-id="element-800">0%</span>
                <span data-id="element-801">100%</span>
              </div>
            </div>
          </div>

          {/* ── 4. Unmatched List ── */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6" data-id="element-802">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center" data-id="element-803">
              <h3 className="font-bold text-gray-900 flex items-center gap-2" data-id="element-804">
                <AlertCircle className="h-5 w-5 text-red-500" data-id="element-805" />
                Unmatched Transactions
              </h3>
              <span className="bg-red-100 text-red-700 px-2.5 py-1 rounded-md text-xs font-bold" data-id="element-806">
                {totalTransactions - matched} items
              </span>
            </div>
            <div className="overflow-x-auto" data-id="element-807">
              <table className="w-full text-sm" data-id="element-808">
                <thead data-id="element-809">
                  <tr className="border-b border-gray-100 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-810">
                    <th className="px-6 py-3 text-left" data-id="element-811">Date</th>
                    <th className="px-6 py-3 text-left" data-id="element-812">Description</th>
                    <th className="px-6 py-3 text-right" data-id="element-813">Bank Amt</th>
                    <th className="px-6 py-3 text-right" data-id="element-814">QB Amt</th>
                    <th className="px-6 py-3 text-left" data-id="element-815">Type</th>
                    <th className="px-6 py-3 text-right" data-id="element-816">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-817">
                  {unmatchedItems.map(item => <tr key={item.id} className="hover:bg-gray-50 transition-colors" data-id="element-818">

                      <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-819">
                        {item.date}
                      </td>
                      <td className="px-6 py-3 font-medium text-gray-900" data-id="element-820">
                        {item.desc}
                      </td>
                      <td className={`px-6 py-3 text-right font-mono whitespace-nowrap ${item.bankAmt.startsWith('+') ? 'text-green-600' : item.bankAmt === '—' ? 'text-gray-400' : 'text-gray-900'}`} data-id="element-821">

                        {item.bankAmt}
                      </td>
                      <td className={`px-6 py-3 text-right font-mono whitespace-nowrap ${item.qbAmt.startsWith('+') ? 'text-green-600' : item.qbAmt === '—' ? 'text-gray-400' : 'text-gray-900'}`} data-id="element-822">

                        {item.qbAmt}
                      </td>
                      <td className="px-6 py-3" data-id="element-823">{getTypeBadge(item.type)}</td>
                      <td className="px-6 py-3 text-right" data-id="element-824">
                        <Button variant="ghost" size="sm" className="h-7 text-xs text-violet-600 hover:text-violet-700 hover:bg-violet-50" data-id="element-825">

                          Review
                        </Button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="px-6 py-3 bg-gray-50 text-center border-t border-gray-100" data-id="element-826">
              <button className="text-sm font-medium text-violet-600 hover:text-violet-700" data-id="element-827">
                View all {totalTransactions - matched} unmatched transactions →
              </button>
            </div>
          </div>

          {/* ── 5. Duplicate Flags ── */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6" data-id="element-828">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center" data-id="element-829">
              <h3 className="font-bold text-gray-900 flex items-center gap-2" data-id="element-830">
                <Copy className="h-5 w-5 text-purple-600" data-id="element-831" />
                Duplicate Flags
              </h3>
              <span className="bg-purple-100 text-purple-700 px-2.5 py-1 rounded-md text-xs font-bold" data-id="element-832">
                7 duplicates
              </span>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-833">
              {duplicateItems.map(item => <div key={item.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-834">

                  <div className="flex items-center gap-4" data-id="element-835">
                    <div className="p-2 bg-purple-100 rounded-full" data-id="element-836">
                      <Copy className="h-4 w-4 text-purple-600" data-id="element-837" />
                    </div>
                    <div data-id="element-838">
                      <p className="font-medium text-gray-900" data-id="element-839">{item.desc}</p>
                      <p className="text-xs text-gray-500" data-id="element-840">
                        {item.date} · {item.amount}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-841">
                    <span className="bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full text-xs font-bold" data-id="element-842">
                      {item.occurrences}× in QB
                    </span>
                    <Button variant="ghost" size="sm" className="h-7 text-xs text-violet-600 hover:text-violet-700 hover:bg-violet-50" data-id="element-843">

                      Resolve
                    </Button>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </main>

      {/* Bottom Action Bar */}
      <div className="bg-white border-t border-gray-200 py-4 px-4 sm:px-6 lg:px-8 sticky bottom-0 z-10" data-id="element-844">
        <div className="max-w-5xl mx-auto flex justify-between items-center" data-id="element-845">
          <Button variant="ghost" onClick={() => navigate('/matched-result')} className="text-gray-500 hover:text-gray-900" data-id="element-846">

            Back to Reconciliation
          </Button>
          <div className="flex items-center gap-4" data-id="element-847">
            <Button variant="primary" onClick={() => navigate('/')} className="min-w-[160px]" data-id="element-848">

              <Home className="mr-2 h-4 w-4" data-id="element-849" />
              Return to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>;
}